<template>
  <div class="intervencao">
    <ul>
      <li
        v-for="item in setores"
        :key="item.id"
        @click="alterarSetor(item)"
        :class="{'active': setorAtivo == item.id}"
      >
          <span v-if="setorAtivo != 7">{{ item.nome }}</span>
          <span v-if="setorAtivo == 7">
              <a href="http://arquivos.ana.gov.br/pnsh/Brasil.zip" target="_blank">{{ item.nome }}</a>
          </span>
      </li>
    </ul>
  </div>
</template>


<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      setores: [
        {
          id: 1,
          nome: 'Brasil'
        },
        {
          id: 2,
          nome: 'Norte, Centro-Oeste e Nordeste Ocidental'
        },
        {
          id: 3,
          nome: 'Nordeste Setentrional'
        },
        {
          id: 4,
          nome: 'Nordeste Meridional'
        },
        {
          id: 5,
          nome: 'Sudeste'
        },
        {
          id: 6,
          nome: 'Sul'
        },
        {
          id: 7,
          nome: 'Todas as fichas resumo'
        }
      ]
    };
  },

  computed: {
      ...mapState({
        'setorAtivo': state => state.Layout.setorAtivo
      })
    },

  methods: {
    ...mapActions({
      setSetorAtivo: 'Layout/setSetorAtivo'
    }),

    alterarSetor (setor) {
      this.setSetorAtivo(setor)
    }
  }
};
</script>


<style lang="scss" scoped>
.intervencao {
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  margin: 0 auto;
  z-index: 9;
  @include media_tablet() {
    display: none;
  }
}
ul {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 5vh;
  background-color: #ffffff;
  li {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e0eef7;
    font-size: 14px;
    text-align: center;
    color: #3994d0;
    padding: 14px;
    height: 8vh;
    width: 13%;
    z-index: 2;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
    }

    a {
      color: #3994d0;
    }

    &:hover {
        box-shadow: 0px 5px 1px #e7e7e7;
        transform: translateY(-4px);
        transition: transform 300ms ease-in-out;
    }

    &:nth-child(7) {
        background-color: transparent;
        background-image: url(../assets/arrow-right-corner.png);
        background-repeat: no-repeat;
        background-position: top right;
        font-weight: bold;

        a {
          color: #fff;
        }

    }

    &.active {
      background-color: #3994d0;
      color: #ffffff;
      font-family: "rubik_bold";
    }
  }
}
</style>
